module.exports = __webpack_public_path__ + "img/m6.05cc538c.png";